import {
  add,
  contains,
  listen,
  qs,
  qsa,
  remove,
  toggle,
} from "@fluorescent/dom";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

import { on } from "@/neon/events";

import { updateFilters } from "@/lib/filters/events";

const sel = {
  filter: "[data-mobile-filter]",
  modal: "[data-mobile-modal]",
  button: "[data-button]",
  wash: "[data-mobile-wash]",
  tag: "[data-tag]",
  sort: "[data-sort]",
  close: "[data-close-icon]",
};

const classes = {
  active: "active",
};

export default node => {
  const pills = qsa(sel.filter, node);
  const modals = qsa(sel.modal, node);
  const wash = qs(sel.wash, node);
  const closeButtons = qsa(sel.close, node);

  const pillClick = listen(pills, "click", clickPill);
  const washClick = listen(wash, "click", clickWash);
  const closeClick = listen(closeButtons, "click", clickWash);
  listen(qsa(sel.button, node), "click", clickButton);

  function clickPill(e) {
    e.preventDefault();
    const { mobileFilter } = e.currentTarget.dataset;

    add(wash, classes.active);
    add(qs(`[data-mobile-modal="${mobileFilter}"]`, node), classes.active);
    disableBodyScroll(node, {
      allowTouchMove: el => {
        while (el && el !== document.body) {
          if (el.getAttribute("data-scroll-lock-ignore") !== null) {
            return true;
          }
          el = el.parentNode;
        }
      },
      reserveScrollBarGap: true,
    });
  }

  function clickWash() {
    remove([...modals, wash], classes.active);
    enableBodyScroll(node);
  }

  function clickButton(e) {
    e.preventDefault();
    const { button } = e.currentTarget.dataset;

    const modal = e.currentTarget.closest(sel.modal);
    if (button === "clear") {
      const inputs = qsa("[data-filter-item-input]", modal);
      inputs.forEach(input => {
        if (input.type === "checkbox" || input.type === "radio") {
          input.checked = false;
        } else {
          input.value = "";
        }
      });
    } else if (button === "apply") {
      const form = e.currentTarget.closest("[data-filter-form]");
      updateFilters(form);
      clickWash();
    }
  }

  return () => {
    pillClick();
    washClick();
    closeClick();
  };
};
